import BaseComponent from './BaseComponent';
import Choices from 'choices.js';
import Rails   from 'rails-ujs';

class InputSelect extends BaseComponent {
  constructor(componentName, autoInit){
    super(componentName);  // Params passed to BaseComponent

    this.options = {
      addItemText: false,
      classNames: {
        containerOuter: 'input--select-wrapper',
        containerInner: 'input--select',
        input         : 'input--select--fake',
        inputCloned   : 'input--select__input--cloned',
        list          : 'input--select__list',
        listItems     : 'input--select__list--multiple',
        listSingle    : 'input--select__list--single',
        listDropdown  : 'input--select__list--dropdown',
        item          : 'input--select__item',
        itemSelectable: 'input--select__item--selectable',
        itemDisabled  : 'input--select__item--disabled',
        itemChoice    : 'input--select__item--choice',
        placeholder   : 'input--select__placeholder',
        group         : 'input--select__group',
        groupHeading  : 'input--select__heading',
        button        : 'input--select__button'
      }
    };

    this.componentName = componentName;
  }


  // <input type='select' class='cmp-input-select input-select--country' data-region-target-id='55'>
  // <input type='select' class='cmp-input-select input-select--region' data-region-id='55'>
  init(component) {
    const selectBlock         = component.element;
    const selectInput         = component.element.getElementsByClassName('input--select--fake')[0];
    const regionId            = component.element.getAttribute('data-region-id');
    const selectedValue       = component.element.getAttribute('data-selected');

    if(!!regionId) {
      const dependantBlock  = document.querySelector(`.${this.componentName}[data-region-target-id='${regionId}']`);
      const dependantInput  = dependantBlock.getElementsByClassName('input--select--fake')[0];

      // Initial Check/Get data regions
      if(dependantInput.value) {
        const url  = this.getUrl(dependantInput.value);

        this.getOptions(url).then((response) => {
          this.addOptions(component, response, !!selectedValue ? selectedValue : undefined);
          if(!!selectInput) {
            component.selectChoices = new Choices(selectInput, this.options);
            this.addCustomEvents(component.element, selectInput);
          }
          this.addWatcher(component, dependantInput);
        });
      }

    } else {
      if(!!selectInput) {
        if (selectInput.classList.contains('no-search')) {
          this.options.searchEnabled = false;
        } else if (selectInput.classList.contains('select--shipment-conditions')) {
          const element = component.element;
        }
        const isAFilter = selectBlock.getAttribute('data-filter') == 'true';
        const customOptions = isAFilter ? { searchEnabled: false, itemSelectText: '' } : {};
        component.selectChoices = new Choices(selectInput, {...this.options, ...customOptions });
        this.options.searchEnabled = true;
        this.addCustomEvents(component.element, selectInput);
      }
    }
  }


  getUrl(regionValue) {
    const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    return `/${lang}/regions/${regionValue}`;
  }


  getOptions(url) {
    return new Promise((resolve, reject) => {
      app.ajax.get(url, (response) => {
        app.parser.parseJSON(response, (parsedResponse) => {
          resolve(parsedResponse);
        });
      });
    });
  }


  addOptions(component, options, selectedValue = undefined) {
    const selectInput = component.element.getElementsByClassName('input--select--fake')[0];
    if(!component.selectChoices) {
      for(let option of options) {

        // TODO: REMOVE existing options in pure vanilla before add new ones
        const value   = option[1];
        const title   = option[0];
        const optionTag     = document.createElement('option');
        optionTag.value     = value;
        optionTag.innerHTML = title;

        if (value == selectedValue) optionTag.setAttribute('selected', true);

        // Appending each option to the select
        selectInput.appendChild(optionTag);
      }
    } else {

      let choices = [];

      for(let [index, option] of options.entries()) {
        const value   = option[1];
        const title   = option[0];

        if(index == 0) {
          choices.push({value: value, label: title, selected: true})
        } else {
          // if(!!selectedValue) {
          //   debugger;
          //   if (value == selectedValue) {
          //     choices.push({value: value, label: title, selected: true})
          //     choices[0].selected = false;
          //   } else {
              choices.push({value: value, label: title});
            // }
          // }
        }
      }

      if(choices.length > 1) {
        component.selectChoices.setChoices(choices, 'value', 'label', true);
      }
    }
  }


  removeOptions() {}


  addWatcher(component, dependantInput) {
    const selectInput = component.element.getElementsByClassName('input--select--fake')[0];

    dependantInput.addEventListener('change', () => {
      const url = this.getUrl(dependantInput.value);

      this.getOptions(url).then((response) => {
        this.addOptions(component, response);
      });
    });
  }


  addCustomEvents(element, selectInput) {
    if(!!selectInput) {
      selectInput.addEventListener('showDropdown', () => {
        element.classList.add('is-focused');
      });

      selectInput.addEventListener('hideDropdown', () => {
        element.classList.remove('is-focused');
        // on change run :
        const form = document.getElementsByClassName('shipment-conditions-form')[0];
        if(!!form) Rails.fire(form, "submit");
      });
    }
  }
}


export default InputSelect;
